exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mask-root-3oq {\n    background-color: black;\n    cursor: pointer;\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0;\n    position: fixed;\n    top: 0;\n    transition-duration: 192ms;\n    transition-property: opacity, visibility;\n    transition-timing-function: linear;\n    visibility: hidden;\n    width: 100%;\n    z-index: 2;\n    -webkit-appearance: none;\n}\n\n/* state: active */\n\n.mask-root_active-1KO {\n    opacity: 0.5;\n    transition-duration: 224ms;\n    visibility: visible;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "mask-root-3oq",
	"root_active": "mask-root_active-1KO mask-root-3oq"
};